import { createBrowserHistory } from 'history';
//import { logPageNavigation } from 'helpers/googleAnalyticsHelper';
const history = createBrowserHistory();
history.listen(location => {
  //logPageNavigation(location);
});
export default history;